import { FC } from "react";

import { Tag } from "antd";

import { useAppSelector } from "@/hooks/redux";

const ServerStatuses: FC = () => {
  const { serverConnected, standConnectionStatus } = useAppSelector(
    (state) => state.serverReducer
  );

  return (
    <div>
      <Tag color={serverConnected ? "green" : "red"}>Server</Tag>
      <Tag
        color={
          standConnectionStatus === "connected"
            ? "green"
            : standConnectionStatus === "no_answer"
            ? "orange"
            : "red"
        }
      >
        Stand
      </Tag>
    </div>
  );
};

export default ServerStatuses;
